export class IUser {
    _id                     : string;
    name                    : string;
    gender                  : string;
    phone                   : string;
    username                : string;
    email                   : string;
    password                : string;
    profile                 : string;
    roleInfo                : string;
    branch                  : string;
    company                 : string;
    cardNo                  : string;
    createdBy               : string;
    modifiedBy              : string;
    userCode                : string;
    salaryType              : string;
    salary                  : number;
    gymShare                : string;
    totalFees               : string;
    trainerShare            : string;
    type                    : string;
    scope                   : string;
    initiatedFrom           : string;
    role                    : any;
    companyAdmin            : boolean;
    hasPettyCashAccount     : boolean;
    pettyCash               : number;
    pettyCashHistory        : IPettyCashHistory[];
    fees                    : IFees[];
    attendanceSlots         : IAttendanceSlot[];
    userLeaves              : IUserLeaves[];
    userWorkFromHome        : IUserWorkFromHome[];
    gymSharePercentage      : number;
    branchName              : String;
    trainerSharePercentage  : number;
}

class IPettyCashHistory {
  id              : string;
  amountAdded     : number;
  amountBefore    : number;
  amountAfter     : number;
  createdBy       : string;
  createdDate     : Date;
}

class IAttendanceSlot {
    _id: string;
    title   : string;
    shouldEndNextDate: boolean;
    from    : Date;
    to      : Date;
    dayOff  : string[];
}
class IUserLeaves {
  enteredBy    : string;
  leaveReason  : string;
  from         : Date;
  to           : Date;
}
class IUserWorkFromHome {
  enteredBy    : string;
  workFromHomeReason  : string;
  from         : Date;
  to           : Date;
}
class IFees {
  _id                 : string;
  title               : string;
  type                : string;
  numberOfSessions    : number;
  numberOfMonths      : number;
  totalFee            : number;
  trainerShare        : number;
  gymShare            : number;
  gymSharePercentage  : number;
  createdBy           : string;
  createdDate         : Date;
  services            : string[];
  subscriptionExpiry  : string;
}